import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';

import { reactPlugin } from 'utils/AppInsightsManager/AppInsightsManager';
import AlertMessage from 'Shared.Components/AlertMessage';
import { RESOURCES_KEYS } from 'utils/i18n/resources';

interface IErrorBoundaryProps {
  children: React.ReactElement;
  title?: string;
}

const ErrorBoundary: React.FunctionComponent<IErrorBoundaryProps> = ({ children, title }) => {
  const { t: translate } = useTranslation();
  return (
    <AppInsightsErrorBoundary
      onError={() => (
        <AlertMessage title={title}>
          <h2>{translate(RESOURCES_KEYS.PLEASE_CONTACT_SUPPORT_TEAM)}.</h2>
        </AlertMessage>
      )}
      appInsights={reactPlugin}>
      {children}
    </AppInsightsErrorBoundary>
  );
};

export default ErrorBoundary;
